import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import Add_ticket from './../../assets/images/add.png';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Pagination from "react-js-pagination";
import Select, { components } from 'react-select';
import ReactMultiSelectCustom from "./../multiselectcustom/ReactMultiSelectCustomSearch";
import { userList, EmployeeDelete, EmployeeViewreport, EmployeeReward, AddCreditReward, AddCreditLeave } from '../../actions/manageEmployeeAction';
import { connect } from "react-redux";
import * as actionFunction from "../../actions/common";
import '../chat/chat.css';
/* Employee Map Start */
import "rsuite/CheckPicker/styles/index.css";
import "../../assets/css/rsuite.css";
import Drawer from "rsuite/Drawer";
import Highcharts from "highcharts";
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
/* Employee Map End */
class ManageEmployee extends Component {
    constructor() {
        super();
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            credit_reward_date: new Date(),
            //           startDate: moment(),
            //           endDate: moment(),
            //           credit_reward_date: moment(),
            fields: {},
            errors: {},
            leave_type_err: '',
            department: [],
            //            formData:{},
            showFilter: false,
            filter_item: {},
            options: [{ label: 'Remote', value: "Remote" }, { label: 'Onsite', value: "Onsite" }],
            pageNumber: 1,
            labeloptions: [{ label: 'R1', value: "R1" }, { label: 'R2', value: "R2" }, { label: 'R3', value: "R3" }, { label: 'R4', value: "R4" }, { label: 'R5', value: "R5" }, { label: 'R6', value: "R6" }, { label: 'R7', value: "R7" }, { label: 'R8', value: "R8" }, { label: 'R9', value: "R9" }],
            resetFilter: 0,
            religion_list: [{ label: "Hindu", value: "Hindu" }, { label: "Muslim", value: "Muslim" }, { label: "Sikh", value: "Sikh" }, { label: "Christian", value: "Christian" }, { label: "Jain", value: "Jain" }, { label: "Buddhist", value: "Buddhist" }, { label: "Prefer not to disclose", value: "Prefer not to disclose" }],
            //Employee Map
            openWithHeader: false,
            showHighcharts: true,
            apiUrl: this.decryptconfigdata('apiUrl'),
            per_city: "",
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.searchChange = this.searchChange.bind(this);
        //        this.departmentChange = this.departmentChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChangeStart = this.handleChangeStart.bind(this);
        this.handleChangeEnd = this.handleChangeEnd.bind(this);
        this.handleChangeCreditReward = this.handleChangeCreditReward.bind(this);
        this.getLeaveType = this.getLeaveType.bind(this);
        //this.onHalfDayFirstChange = this.onHalfDayFirstChange.bind(this);
        //this.onHalfDaySecondChange = this.onHalfDaySecondChange.bind(this);
        this.resetHandler = this.resetHandler.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    componentDidMount() {
        var page = 1
        const post = {
            page: page
        }
        document.title = "Intranet | Employee";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.props.userList(post);
    }

    getLeaveType() {
        var leave_type_val = document.getElementById('leave_type');
        if (leave_type_val.value != "") {
            this.setState({ leave_type: leave_type_val.value, leave_type_err: "", });
            document.getElementById("credit_leave").disabled = false;
        } else {
            this.setState({ leave_type: '', })
        }
    }
    handleChangeStart(date) {
        this.setState({
            startDate: date,
            start_date: moment(date).format("YYYY-MM-DD"),
            registered_mail: "",
            leave_type_err: ""
        });
        document.getElementById("credit_leave").disabled = false;
    }

    handleChangeEnd(date) {
        this.setState({
            endDate: date,
            end_date: moment(date).format("YYYY-MM-DD"),
            registered_mail: "",
            leave_type_err: ""
        });
        document.getElementById("credit_leave").disabled = false;
    }

    handleChangeCreditReward(date) {
        this.setState({
            credit_reward_date: date,
            reward_date: moment(date).format("YYYY-MM-DD")
        });
    }

    onChange(event) {
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;

    }
    searchChange(event) {
        var obj = this;
        //Delaying the function execute
        this.setState({ search: event.target.value }, function () {
            const post = {
                search: this.state.search,
                page: 1,
                filter_item: this.state.filter_item
            }
            //Delaying the function execute
            if (this.timer) {
                window.clearTimeout(this.timer);
            }
            this.timer = window.setTimeout(function () {
                obj.props.userList(post)
            }, 500);
        });
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        if (!fields["credit_reward"]) {
            formIsValid = false;
            errors["credit_reward"] = "Please Provide Reward.";
        }
        if (fields["credit_reward"] && !this.isValidNumber(fields["credit_reward"])) {
            formIsValid = false;
            errors["credit_reward"] = "Please Provide Numbers Only.";
        }
        if (this.state.reward_type == 2) {
            if (fields["credit_reward"] && fields["credit_reward"] == 0) {
                formIsValid = false;
                errors["credit_reward"] = "Redeem point should be greater than 0 and less than available reward points.";
            }
            if (fields["credit_reward"] && !this.checkRewardAvailability(fields["credit_reward"])) {
                formIsValid = false;
                errors["credit_reward"] = "Redeem point should be less than available reward points";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    isValidNumber(number) {
        var pattern = /^[0-9]+$/;
        return pattern.test(number);
    }

    checkRewardAvailability(reward_point) {
        var available_reward_point = this.props.total_reward;
        if (Number(reward_point) > Number(available_reward_point)) {
            return false;
        } else {
            return true;
        }
    }

    back() {
        window.location.href = '/employees/';
    }
    export() {
        var commonStateData = actionFunction.commonData()
        var win = window.open(commonStateData.apiUrl + "/HrmanagementRest/ExportAdvanced/userAuthKey/" + commonStateData.userAuthKey + "/department/" + this.state.department + "/search/" + this.state.search, '_self');
        win.focus()
    }
    handlePageChange(pageNumber = 1) {
        var page = pageNumber;
        this.setState({ pageNumber });
        const post = {
            page: page,
            search: this.state.search,
            filter_item: this.state.filter_item
        };
        this.props.userList(post);
    }

    delete_employee(id) {
        if (window.confirm('Are you sure delete this employee')) {
            var page = 1;
            const post = {
                id: id,
                page: page,
                search: this.state.search
            };
            this.props.EmployeeDelete(post);
        }
    }
    edit_employee(id) {
        this.props.history.push('/viewEmployee/' + id);
    }
    id(id, reward_type) {
        var reward_type_text = (reward_type == 1) ? "Credit" : "Redeem";
        var st_date = moment(this.state.startDate).format("YYYY-MM-DD")
        var en_date = moment(this.state.endDate).format("YYYY-MM-DD")
        if (st_date == en_date) {
            document.getElementById('leave_type').value = "";
        }
        document.getElementById('leave_note').value = "";
        document.getElementById('leave_note_err').innerHTML = "";
        document.getElementById("credit_leave").disabled = false;
        if (reward_type) {
            this.setState({ errors: {} });
            document.getElementById('credit_reward').value = "";
            document.getElementById('reward_note').value = "";
        }
        this.setState({ registered_mail: "", leave_type_err: "", startDate: new Date(), endDate: new Date(), });

        { this.setState({ empId: id, reward_type, reward_type_text }) }
        const post = {
            id: id,
        }
        this.props.EmployeeReward(post)

    }
    quizStatus(status) {
        switch (status) {
            case '1':
                return 'Pass';
            case '0':
                return 'Fail';
            default:
                return '--';
        }
    }
    viewreport(id) {
        const post = {
            id: id,
        }
        this.props.EmployeeViewreport(post)
    }
    getUsersMenu(id, leave) {
        return (
            <ul class="onclick-menu-content">
                {/* <li><Link  to={`/viewEmployee/${id}`} name={"max"}><i class="fa fa-pencil-square-o" aria-hidden="true"></i></Link></li> */}
                {/* <li> <span class="delete" onClick={() => this.delete_employee(id)}><i class="fa fa-trash" aria-hidden="true"></i></span></li> */}
                {/* <li><Link to={`/viewEmployee/${id}`} name={"max"}>Edit</Link></li> */}
                <li onClick={() => this.edit_employee(id)}>Edit</li>
                <li onClick={() => this.delete_employee(id)} ><a>Delete</a></li>
                {/*<li onClick={() => this.viewreport(id)} data-toggle="modal" data-target="#ViewReport"><a>View Report</a></li>*/}
                {/* {leave <= 0 ? <li onClick={() => this.id(id)} data-toggle="modal" data-target="#failedLeaveModal"><a>Apply Leave</a></li> : <li onClick={() => this.id(id)} data-toggle="modal" data-target="#creditLeaveModal"><a>Apply Leave</a></li>} */}
                <li onClick={() => this.id(id)} data-toggle="modal" data-target="#creditLeaveModal"><a>Apply Leave</a></li>
                <li onClick={() => this.id(id, 1)} data-toggle="modal" data-target="#creditRewardModal"><a>Credit Reward</a></li>
                <li onClick={() => this.id(id, 2)} data-toggle="modal" data-target="#creditRewardModal"><a>Redeem Reward</a></li>
            </ul>
        )
    }
    creditLeave(id, leave_available) {
        // const fd = new FormData;
        document.getElementById("credit_leave").disabled = true;
        // fd.append('inputs', JSON.stringify(this.state));
        var st_date = moment(this.state.startDate).format("YYYY-MM-DD")
        var en_date = moment(this.state.endDate).format("YYYY-MM-DD")
        if (st_date == en_date) {
            var leave_type = document.getElementById("leave_type");
            if (leave_type.value == "") {
                this.setState({ leave_type_err: "Please select leave type" }, function () {
                });
                return false;
            }
        }
        const post = {
            id: id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            leave_type: this.state.leave_type,
            leave_note: this.state.leave_note,
            leave_available: leave_available,
            is_lop: this.state.is_lop
        }
        this.props.AddCreditLeave(post)
    }
    creditReward(id) {
        if (!this.handleValidation()) {
            return false;
        }
        document.getElementById("edit_reward_button").innerHTML = "Updating....";
        const post = {
            empId: id,
            credit_reward: this.state.credit_reward,
            reward_note: this.state.reward_note,
            reward_date: this.state.reward_date,
            reward_type: this.state.reward_type,
        }
        this.props.AddCreditReward(post)
    }

    getReactSelectData = (formDataUpdated) => {
        //        console.log(300,...formDataUpdated);
        var obj = this;
        //        console.log(301,this.state.filter_item)
        var pageNumber = 1;
        this.setState({ filter_item: { ...this.state.filter_item, ...formDataUpdated }, resetFilter: 0 }, function () {
            //            console.log(301,this.state.filter_item)
            if (this.timer) {
                window.clearTimeout(this.timer);
            }
            const post = {
                page: pageNumber,
                filter_item: obj.state.filter_item,
                search: this.state.search
            }
            this.timer = window.setTimeout(function () {
                obj.props.userList(post)
            }, 500);
        });
    }

    filterHandler(e, val) {
        const pageNumber = 1;
        let filter_item = { ...this.state.filter_item };

        if (val !== undefined && typeof val === "object") {
            if (Array.isArray(val)) {
                filter_item[e] = val.map((item) => item.value);
            } else if (val.hasOwnProperty("value")) {
                filter_item[e] = val.value;
            } else if (val.target && val.target.value) {
                filter_item[e] = val.target.value;
            }
        } else if (typeof val === "string") {
            filter_item[e] = val;
        }

        this.setState({ filter_item }, () => {
            if (this.timer) {
                window.clearTimeout(this.timer);
            }
            const post = {
                page: pageNumber,
                filter_item: this.state.filter_item,
                search: this.state.search,
            };
            this.timer = window.setTimeout(() => {
                this.props.userList(post);
            }, 500);
        });
    }

    onRemoveHandler(k, e) {
        let filter_item = this.state.filter_item;
        const remove_item = { [k]: e.map((item) => item.id) }
        const remove_values = Object.values(remove_item);
        let obj;
        if (remove_values.length == 0) {
            obj = { ...delete this.state.filter_item[k], ...this.state.filter_item };
        } else {
            obj = remove_item;
        }
        this.setState({ filter_item }, function () {
            this.props.userList(this.state.filter_item);
        })
    }

    showAdvFilter(divId) {
        var element = document.getElementById(divId);
        element.classList.toggle("show");
        if (divId == "adv_filter")
            this.setState({ showFilter: !this.state.showFilter });
    }

    getFilter() {
        return (
            <div id="adv_filter" class="adv_filter filter-wrap">
                <div class="containerfull">
                    <div class="row">
                        <div class="col-md-4 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">Level</label>
                                <ReactMultiSelectCustom
                                    options={this.state.labeloptions}
                                    field_name="level"
                                    getSelectedData={this.getReactSelectData}
                                    resetFilter={this.state.resetFilter}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">Work Location</label>
                                <ReactMultiSelectCustom
                                    options={this.state.options}
                                    field_name="worklocation"
                                    getSelectedData={this.getReactSelectData}
                                    resetFilter={this.state.resetFilter}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">Department</label>
                                <ReactMultiSelectCustom
                                    options={this.props.department_group.map((item) => {
                                        return { label: item.name, value: item.id }
                                    })}
                                    field_name="department"
                                    getSelectedData={this.getReactSelectData}
                                    resetFilter={this.state.resetFilter}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">Country</label>
                                <Select
                                    value={this.state.filter_item && this.state.filter_item.hasOwnProperty('per_country') ?
                                        this.props.country_list.filter((na) => na.value === this.state.filter_item.per_country)
                                        : ""}
                                    className="single-select"
                                    classNamePrefix="single-select"
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={(event) => this.filterHandler('per_country', event)}
                                    options={this.props.country_list.map((item) => {
                                        return { label: item.label, value: item.value }
                                    })}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">State</label>
                                <Select
                                    value={this.state.filter_item && this.state.filter_item.hasOwnProperty('per_state') ?
                                        this.props.state_list.filter((na) => na.value === this.state.filter_item.per_state)
                                        : ""}
                                    className="single-select"
                                    classNamePrefix="single-select"
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={(event) => this.filterHandler('per_state', event)}
                                    options={this.props.state_list.map((item) => {
                                        return { label: item.label, value: item.value }
                                    })}
                                />
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">City</label>
                                <div class="w-100">
                                    <div class="text_filter dropdown bootstrap-select show-tick productselect bs3">
                                        <input
                                            type="text"
                                            placeholder="Type City Name"
                                            className="form-control input-f"
                                            value={this.state.per_city || ""}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                this.setState({ per_city: value }, () => {
                                                    this.filterHandler("per_city", value);
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">Religion</label>
                                <ReactMultiSelectCustom
                                    options={this.state.religion_list}
                                    field_name="religion"
                                    getSelectedData={this.getReactSelectData}
                                    resetFilter={this.state.resetFilter}
                                />
                            </div>
                        </div>
                        {/*<div class="col-lg-1 more-row">
                                <div class="d-flex">
                                    <div class="col-md-auto">
                                        <div class="reset-btn btn-border" onClick={(e) => this.resetFilter()}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.666748 2.66666V6.66666H4.66675" stroke="#202223" stroke-opacity="0.5" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path><path d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667" stroke="#202223" stroke-opacity="0.5" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                                        </div>
                                    </div>
                                </div>
                            </div>*/}
                    </div>
                </div>
            </div>
        )
    }

    getUserRows() {
        return (<div class="body-content">
            <div class="employee-list table-wrap">
                <table>
                    <thead>
                        <th width="410">Name</th>
                        <th width="350">Email Id</th>
                        <th width="200">Phone Number</th>
                        <th width="400">Department</th>
                        {this.props.hr_permission == 'yes' ? <th>Action</th> : ""}
                    </thead>
                    {this.props.loading ?
                        <tbody>
                            <tr>
                                <td colSpan="5" style={{ textAlign: "center", height: "370px" }}><div class="loader-new"></div></td>
                            </tr>
                        </tbody> :
                        <tbody>
                            {this.props.user.length > 0 ?
                                this.props.user.map((item, index) =>
                                    <tr>
                                        <td>
                                            <div class="emps_details">
                                                <div class="emps_pic">
                                                    <img src={item.profile_image} />
                                                </div>
                                                <Link to={`/viewEmployee/${item.id}`}>{item.name.length > 25 ? item.name.substr(0, 25) + ' ...' : item.name}</Link>
                                            </div>
                                        </td>
                                        <td>{item.email}</td>
                                        <td>{item.per_phoneno}</td>
                                        <td>
                                            <span data-tooltip={item.department} data-position="bottom">{item.department && item.department.length > 30 ? item.department.substr(0, 30) + ' ...' : item.department}</span>
                                        </td>
                                        {this.props.hr_permission == 'yes' ?
                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.99992 8.66668C8.36811 8.66668 8.66659 8.3682 8.66659 8.00001C8.66659 7.63182 8.36811 7.33334 7.99992 7.33334C7.63173 7.33334 7.33325 7.63182 7.33325 8.00001C7.33325 8.3682 7.63173 8.66668 7.99992 8.66668Z" fill="#373945" stroke="#373945" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M7.99992 3.99999C8.36811 3.99999 8.66659 3.70151 8.66659 3.33332C8.66659 2.96513 8.36811 2.66666 7.99992 2.66666C7.63173 2.66666 7.33325 2.96513 7.33325 3.33332C7.33325 3.70151 7.63173 3.99999 7.99992 3.99999Z" fill="#373945" stroke="#373945" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M7.99992 13.3333C8.36811 13.3333 8.66659 13.0349 8.66659 12.6667C8.66659 12.2985 8.36811 12 7.99992 12C7.63173 12 7.33325 12.2985 7.33325 12.6667C7.33325 13.0349 7.63173 13.3333 7.99992 13.3333Z" fill="#373945" stroke="#373945" stroke-linecap="round" stroke-linejoin="round" />
                                                        </svg>
                                                    </button>
                                                    <ul class="dropdown-menu emp-menu" aria-labelledby="dropdownMenu2">
                                                        <li><Link to={`/viewEmployee/${item.id}`} name={"max"}>Edit</Link></li>
                                                        <li onClick={() => this.delete_employee(item.id)} ><a>Delete</a></li>
                                                        <li onClick={() => this.id(item.id)} data-toggle="modal" data-target="#creditLeaveModal"><a>Apply Leave</a></li>
                                                        <li onClick={() => this.id(item.id, 1)} data-toggle="modal" data-target="#creditRewardModal"><a>Credit Reward</a></li>
                                                        <li onClick={() => this.id(item.id, 2)} data-toggle="modal" data-target="#creditRewardModal"><a>Redeem Reward</a></li>
                                                    </ul>
                                                </div>
                                            </td> : ""}
                                    </tr>
                                ) : <tr><td colSpan="5" style={{ textAlign: "center" }}>No data found</td></tr>}
                        </tbody>
                    }
                </table>
            </div>
            <div class="d-flex mu-pagination justify-content-between align-items-center" aria-label="Page navigation example">
                <div class="txt-dark">Showing {this.props.offset + 1}~{this.props.offset + this.props.off_count} of {this.props.item_count}</div>
                <div class="mu-pagination">
                    <Pagination
                        activePage={this.props.activePage}
                        itemsCountPerPage={20}
                        totalItemsCount={this.props.item_count}
                        pageRangeDisplayed={5}
                        itemClass="page-item"
                        linkClass="page-link"
                        onChange={this.handlePageChange}
                    />
                </div>
            </div>
        </div>
        )
    }

    getRangeCheck() {
        var st_date = moment(this.state.startDate).format("YYYY-MM-DD")
        var en_date = moment(this.state.endDate).format("YYYY-MM-DD")
        if (st_date == en_date) {
            return (
                <div class="col-md-6">
                    Leave Type
                    <select class="form-control" name="leave_type" id="leave_type" onChange={this.getLeaveType}>
                        <option value="">-- Select --</option>
                        <option value="first_half">First Half</option>
                        <option value="second_half">Second Half</option>
                        <option value="entire_day">Entire Day</option>
                    </select>
                    <span class="error" id="leave_type_err">{this.state.leave_type_err}</span>
                </div>
            )
        }
    }

    /* customer Map Start */

    async getCustomerMapData() {
        const topology = await fetch(
            'https://code.highcharts.com/mapdata/countries/in/custom/in-all-disputed.topo.json'
        ).then(response => response.json());

        topology.objects.default.geometries.forEach((geometry) => {
            if (geometry.properties.name === "Orissa") {
                geometry.properties.name = "Odisha";
            }
        });

        // const data = await fetch(`${process.env.REACT_APP_CRM}/crm/get-employee-data-map`)
        const data = await fetch(`${this.state.apiUrl}/employee/getemployeedatamap`, {
            method: 'GET',
            dataType: 'json',
        })
            .then((response) => response.json())
            .catch((error) => console.error("Error fetching map data:", error));

        Highcharts.mapChart("worldwide_customer_chart", {
            chart: {
                map: topology,
                height: 650,
                mapNavigation: {
                    enabled: false,
                },
            },
            exporting: {
                buttons: {
                    contextButton: {
                        enabled: false,
                    },
                },
            },
            title: {
                text: "",
                align: "center",
                verticalAlign: "bottom",
                y: 10,
                style: {
                    fontSize: "12px",
                    color: "rgb(102, 102, 102)",
                },
            },
            subtitle: {
                text: "",
            },
            credits: {
                enabled: false,
            },
            mapNavigation: {
                enabled: true,
                buttonOptions: {
                    verticalAlign: "bottom",
                },
            },
            // colorAxis: {
            // 	min: 1,
            // 	type: "logarithmic",
            // 	minColor: "#EEEEFF",
            // 	maxColor: "rgb(25, 103, 210)",
            // 	stops: [
            // 		[0, "#EFEFFF"],
            // 		[0.67, "#4444FF"],
            // 		[1, "#000022"],
            // 	],
            // },
            tooltip: {
                formatter: function () {
                    return `${this.point.name}: ${this.point.value}`;
                },
            },
            legend: {
                enabled: false,
            },
            series: [
                {
                    data: data.response,
                    name: '',
                    states: {
                        hover: {
                            color: "#0063e1",
                        },
                    },
                    dataLabels: {
                        enabled: false,
                        format: "{point.name}",
                    },
                    point: {
                        events: {
                            click: (event) => {
                                const clickedState = event.point.name;
                                const url = new URL(window.location.href);
                                url.searchParams.set("state", clickedState);
                                window.history.pushState({}, "", url.toString());

                                this.filterHandler("per_state", clickedState);

                                this.setState({ openWithHeader: false });
                            },
                        },
                    },

                },
            ],
        });
    }

    /* customer Map End */

    /* Reset Handler Start */
    resetHandler() {
        console.log('Reset Handler Triggered');
        this.setState({
            filter_item: null,
            search: "",
            pageNumber: 1,
            resetFilter: this.state.resetFilter + 1,
            per_city: "",
        }, () => {
            const post = {
                page: 1,
            };
            this.props.userList(post);
        });

        this.props.history.push('/employees');
    }
    /* Reset Handler End */

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        //        console.log("users permission", this.props.hr_permission)
        return (
            <div>
                <Header brecum_name="Employee" brecum_page="Employees" />
                <div class="right_col emp-page">
                    <div class="customer-wrap">
                        <div class="page-top">
                            <div class="containerfull">
                                <div class="row">
                                    <div class="col-md-4">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="mt-10">
                                                    <div class="d-flex align-items-center">
                                                        <h2>Employee</h2>
                                                        <span class="badge-blue">{this.props.item_count}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-1"></div>
                                    <div class="col-md-7">
                                        <div class="d-flex">
                                            <div class="searchTicket emp_dept">
                                                <input type="text" class="form-control input-f" autocomplete="off" name="search" id="search" placeholder="Search by name, email, or phone no" onChange={this.searchChange} />
                                                <button type="submit">
                                                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                        <path d="M15.75 16.25L12.4875 12.9875" stroke="white" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                            <div id="toggle-btnf" class={'toogle-btn' + (this.state.showFilter ? " collapse-state" : "")} onClick={() => this.showAdvFilter('adv_filter')}>
                                                <svg width="17" height="44" viewBox="0 0 17 44" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1134_22629)"><path d="M1.66992 18H15.6699" stroke="#5C5F62" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.16992 22H13.1699" stroke="#5C5F62" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path><path d="M7.16992 26H10.1699" stroke="#5C5F62" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_1134_22629"><rect width="16" height="44" fill="white" transform="translate(0.669922)"></rect></clipPath></defs></svg>
                                            </div>
                                            <div class="toogle-btn" onClick={this.resetHandler} style={{ height: "40px" }}>
                                                <span>
                                                    <svg
                                                        width="16"
                                                        height="16"
                                                        viewBox="0 0 16 16"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path
                                                            d="M0.666748 2.66666V6.66666H4.66675"
                                                            stroke="#202223"
                                                            stroke-opacity="0.5"
                                                            stroke-width="1.33"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        ></path>
                                                        <path
                                                            d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667"
                                                            stroke="#202223"
                                                            stroke-opacity="0.5"
                                                            stroke-width="1.33"
                                                            stroke-linecap="round"
                                                            stroke-linejoin="round"
                                                        ></path>
                                                    </svg>
                                                </span>
                                            </div>
                                            <div
                                                class="toogle-btn"
                                                onClick={() => this.setState({ openWithHeader: true })}
                                                style={{ height: "40px" }}
                                            >
                                                <span>
                                                    <svg
                                                        stroke="currentColor"
                                                        fill="none"
                                                        stroke-width="2"
                                                        viewBox="0 0 24 24"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        height="16"
                                                        width="16"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
                                                        <circle cx="12" cy="10" r="3"></circle>
                                                    </svg>
                                                </span>
                                            </div>
                                            {this.props.hr_permission == 'yes' ?
                                                <div class="left-section pull-right">
                                                    <Link to="/addEmployee" class="btn btn-sky mob">
                                                        <span class="hidden-sm">Add Employee</span>
                                                    </Link>
                                                </div>
                                                : ''}
                                            <div class="clear"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.getFilter()}
                        {this.getUserRows()}
                        <div class="top-row">
                            {/* <--modal start for Credit Leave-!> */}
                            <div class="modal fade" id="creditLeaveModal" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal" >&times;</button>
                                            <h4 style={{ color: "black" }} class="modal-title">Apply Leave</h4>
                                        </div>
                                        <div class="modal-body">
                                            <div class="form-group">
                                                <input type="hidden" class="form-control" name="leave_id" value={this.props.emp_id} />
                                                Employee Name
                                                <input type="text" class="form-control" name="leave_name" placeholder="Employee Name" value={this.props.emp_name} disabled />
                                            </div>
                                            <input type="hidden" class="form-control" name="leave_muvi_id" placeholder="Employee Id" value={this.props.muvi_employee_id} disabled />
                                            <div class="form-group leave-main">
                                                <div class="leave_show col-md-2">
                                                    <div class="leave-sub">Carry Forward</div>
                                                    <div class="leave-sub leave-sub1">{this.props.total_carry_forward_leave}</div>
                                                </div>
                                                <div class="leave_show col-md-2">
                                                    <div class="leave-sub">Yearly Allotted ({this.props.level})</div>
                                                    <div class="leave-sub leave-sub1">{this.props.yearly_leave_label_wise && this.props.yearly_leave_label_wise}</div>
                                                </div>
                                                <div class="leave_show col-md-2">
                                                    <div class="leave-sub">Leave Available (Q{this.props.current_quarter})</div>
                                                    <div class="leave-sub leave-sub1">{this.props.total_leave_available}</div>
                                                </div>
                                                <div class="leave_show col-md-2">
                                                    <div class="leave-sub">Leave Taken</div>
                                                    <div class="leave-sub leave-sub1">{this.props.leaves_taken}</div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        From Date
                                                        <DatePicker
                                                            selected={this.state.startDate}
                                                            startDate={this.state.startDate}
                                                            onChange={this.handleChangeStart}
                                                            dateFormat="dd/MM/yyyy"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            onKeyDown={e => e.preventDefault()}
                                                        />
                                                    </div>
                                                    <div class="col-md-6">
                                                        To Date
                                                        <DatePicker
                                                            selected={this.state.endDate}
                                                            selectsStart
                                                            startDate={this.state.startDate}
                                                            endDate={this.state.endDate}
                                                            onChange={this.handleChangeEnd}
                                                            dateFormat="dd/MM/yyyy"
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                            dropdownMode="select"
                                                            onKeyDown={e => e.preventDefault()}
                                                        />

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="row">
                                                    {this.getRangeCheck()}
                                                    <div class="col-md-6">
                                                        LOP<br />
                                                        <label class="lop-switch">
                                                            <input type="checkbox" name="is_lop" onChange={this.onChange} />
                                                            <span class="slider round"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                Reason for Leave
                                                <textarea type="text" name="leave_note" id="leave_note" class="form-control" onChange={this.onChange}></textarea>
                                                <span class="error" id="leave_note_err">{this.props.registered_mail}</span>
                                                <br></br>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-blue" data-dismiss="modal">Cancel</button>
                                            <button type="button" class="btn btn-sky" id="credit_leave" onClick={() => this.creditLeave(this.props.emp_id, this.props.total_leave_available)}>Apply</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for Credit Leave-!> */}

                            {/* <--modal start for Credit Reward-!> */}
                            <div class="modal fade" id="creditRewardModal" role="dialog">
                                <div class="modal-dialog modal-md">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 style={{ color: "black" }} class="modal-title">{this.state.reward_type_text} Reward</h4>
                                        </div>
                                        <div class="modal-body">
                                            <div class="row">
                                                <div class="col-md-12 form-group">
                                                    <label for="reward-title">Name</label>
                                                    <div class="filter">
                                                        <input type="hidden" class="form-control" name="reward_id" value={this.props.emp_id} />
                                                        <input type="hidden" class="form-control" name="is_credited" value={this.state.reward_type} />
                                                        <input type="text" class="form-control" name="reward_name" placeholder="Employee Name" value={this.props.emp_name} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 form-group">
                                                    <label for="reward-title">Employee Id</label>
                                                    <div class="filter">
                                                        <input type="text" class="form-control" name="reward_muvi_id" placeholder="Employee Id" value={this.props.muvi_employee_id} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 form-group">
                                                    <label for="reward-title">Reward Points {(this.state.reward_type == 2) ? ` (Available - ${this.props.total_reward})` : ""}</label>
                                                    <div class="filter">
                                                        {(this.state.reward_type == 2) ?
                                                            <input type="text" class="form-control" id="credit_reward" name="credit_reward" min="0" max={this.props.total_reward} onChange={this.onChange} placeholder="Redeem Reward" />
                                                            :
                                                            <input type="text" class="form-control" id="credit_reward" name="credit_reward" min="0" onChange={this.onChange} placeholder="Credit Reward" />
                                                        }
                                                        <span class="error">{this.state.errors["credit_reward"]}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 form-group">
                                                    <label for="reward-title">Date</label>
                                                    <div class="filter">
                                                        <DatePicker
                                                            onKeyDown={e => e.preventDefault()}
                                                            selected={this.state.credit_reward_date}
                                                            onChange={this.handleChangeCreditReward}
                                                            minDate={this.state.credit_reward_date}
                                                            dateFormat="dd/MM/yyyy"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-12 form-group">
                                                    <label for="reward-title">Reason</label>
                                                    <div class="filter">
                                                        <textarea type="text" id="reward_note" name="reward_note" class="form-control" onChange={this.onChange}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-blue" data-dismiss="modal">Cancel</button>
                                            <button type="button" class="btn btn-sky" id="edit_reward_button" onClick={() => this.creditReward(this.props.emp_id)}>Update</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <--modal end for Credit Reward-!> */}
                        </div>
                    </div>
                </div>
                <Drawer
                    open={this.state.openWithHeader}
                    onClose={() => this.setState({ openWithHeader: false })}
                    onOpen={() => this.getCustomerMapData()}
                    size="md"
                >
                    <Drawer.Header>
                        <Drawer.Title>Employee Map</Drawer.Title>
                        <Drawer.Actions></Drawer.Actions>
                    </Drawer.Header>
                    <Drawer.Body>
                        <div id="worldwide_customer_chart" className="product-graph"></div>
                    </Drawer.Body>
                </Drawer>
            </div>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        user: state.mEmRe.user,
        department_group: state.mEmRe.department_group,
        hr_permission: state.mEmRe.hr_permission,
        item_count: state.mEmRe.item_count,
        setPage: 'yes',
        activePage: state.mEmRe.activePage,
        off_count: state.mEmRe.off_count,
        offset: state.mEmRe.offset,
        MyPerform_answer: state.mEmRe.MyPerform_answer,
        MyPerform_question: state.mEmRe.MyPerform_question,
        overallScore: state.mEmRe.overallScore,
        comment_result: state.mEmRe.comment_result,
        available_leaves: state.mEmRe.available_leaves,
        emp_name: state.mEmRe.emp_name,
        muvi_employee_id: state.mEmRe.muvi_employee_id,
        emp_id: state.mEmRe.emp_id,
        registered_mail: state.mEmRe.registered_mail,
        loading: state.mEmRe.loading,
        level: state.mEmRe.level,
        yearly_leave_label_wise: state.mEmRe.yearly_leave_label_wise,
        quarterly_leave_earned: state.mEmRe.quarterly_leave_earned,
        carry_forward_leave_earned: state.mEmRe.carry_forward_leave_earned,
        total_carry_forward_leave: state.mEmRe.total_carry_forward_leave,
        total_leave_credited: state.mEmRe.total_leave_credited,
        total_leave_available: state.mEmRe.total_leave_available,
        lop_cnt: state.mEmRe.lop_cnt,
        total_reward: state.mEmRe.total_reward,
        advance_leave: state.mEmRe.advance_leave,
        leaves_taken: state.mEmRe.leaves_taken,
        current_quarter: state.mEmRe.current_quarter,
        country_list: state.mEmRe.country_list,
        state_list: state.mEmRe.state_list,
        religion_list: state.mEmRe.religion_list
    }
}
const mapDispatchToProps = {
    userList,
    EmployeeDelete,
    EmployeeViewreport,
    EmployeeReward,
    AddCreditReward,
    AddCreditLeave
}
export default connect(mapStateToProps, mapDispatchToProps)(ManageEmployee);



// WEBPACK FOOTER //
// ./src/components/hrAdmin/manageEmployee.js